import { Button, Modal } from '@energybox/react-ui-library/dist/components';
import React from 'react';
import { connect } from 'react-redux';
import {
  Actions as DistributionPanelActions,
  destroy,
  getDistributionPanelsBySiteId,
  hideDeleteDistributionPanelModal,
  unstageDelete,
} from '../../actions/distribution_panel';
import history from '../../history';
import { ApplicationState } from '../../reducers';
import { ApiError, renderAPIerror } from '../../utils/apiErrorFeedback';
import { enqueueGatewayAction, GatewayAction } from '../../actions/streamApi';
import { unstageDelete as unstageEProDelete } from '../../actions/energy_pros';

interface Props {
  isVisible: boolean;
  primedForDelete: number;
  primedEProForDelete?: number;
  onDelete: (id: number, eproId?: number) => void;
  onClose: () => void;
  unstageDelete: () => void;
  apiError: ApiError;
  redirectAfterDelete?: boolean;
  panelTitle?: string;
  siteId?: number;
  getDistributionPanelsBySiteId: (siteId: number) => void;
}

class DeleteDistributionPanelModal extends React.Component<Props> {
  render() {
    if (!this.props.isVisible) return null;

    const {
      onDelete,
      onClose,
      apiError,
      primedForDelete,
      primedEProForDelete,
      redirectAfterDelete,
      panelTitle,
      siteId,
      getDistributionPanelsBySiteId,
    } = this.props;

    const confirmDelete = (id: number, eproId?: number) => {
      onDelete(id, eproId);
      if (redirectAfterDelete) {
        history.goBack();
      }
      if (siteId) {
        setTimeout(() => {
          getDistributionPanelsBySiteId(siteId);
        }, 2000);
      }
    };

    const actions = (
      <>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>

        <Button
          onClick={() => {
            confirmDelete(primedForDelete, primedEProForDelete);
          }}
        >
          Delete
        </Button>
      </>
    );
    return (
      <Modal actions={actions}>
        <div style={{ padding: '1rem 2rem' }}>
          <div style={{ textAlign: 'justify', textAlignLast: 'center' }}>
            <div style={{ padding: '1rem 0' }}>
              Are you sure you want to delete{' '}
              {panelTitle ? (
                <span style={{ fontWeight: 'bold' }}>{panelTitle}</span>
              ) : (
                'this distribution panel'
              )}
              ?
            </div>
            {renderAPIerror(
              apiError,
              DistributionPanelActions.DELETE_DISTRIBUTION_PANEL_ERROR
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = ({
  distributionPanels,
  energyPros,
}: ApplicationState) => {
  return {
    panelTitle:
      distributionPanels.distributionPanelsById[
        distributionPanels.primedForDelete
      ] &&
      distributionPanels.distributionPanelsById[
        distributionPanels.primedForDelete
      ].title,
    isVisible: distributionPanels.showDeleteDistributionPanelModal,
    primedForDelete: distributionPanels.primedForDelete,
    primedEProForDelete: energyPros.primedForDelete,
    apiError:
      distributionPanels.editById[distributionPanels.primedForDelete] &&
      distributionPanels.editById[distributionPanels.primedForDelete].apiError,
  };
};

const mapDispatchtoProps = (dispatch: any) => ({
  onDelete: (id: number, eproId?: number) => {
    dispatch(destroy(id));
    eproId !== undefined &&
      eproId !== -1 &&
      dispatch(
        enqueueGatewayAction(GatewayAction.CLEAR_PRO2_CONFIG, String(eproId))
      );
  },
  onClose: () => {
    dispatch(unstageDelete());
    dispatch(unstageEProDelete());
    dispatch(hideDeleteDistributionPanelModal());
  },
  unstageDelete: () => {
    dispatch(unstageDelete());
    dispatch(unstageEProDelete());
  },
  getDistributionPanelsBySiteId: (siteId: number) => {
    dispatch(getDistributionPanelsBySiteId(siteId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchtoProps
)(DeleteDistributionPanelModal);
